<template>
  <div class="row">
    <label class="col-6">{{ minLabel }}</label>
    <label class="col-6 text-right">{{ maxLabel }}</label>
    <el-slider class="col-md-12"
               :class="sliderClass"
               :value="newValue"
               :min="0"
               :max="10"
               @input="setSlider">
    </el-slider>
    <div class="col-md-12">
      <div class="discrete-buttons">
        <span :style="getStyle(index)" v-for="(value, index) in values" @click="setSlider(value)">{{ value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import { Slider } from 'element-ui'

  export default {
    name: 'OpinionSlider',
    props: {
      value: {
        type: Number
      },
      minLabel: {
        type: String
      },
      maxLabel: {
        type: String
      }
    },
    data () {
      return {
        newValue: 0
      }
    },
    mounted () {
      this.newValue = this.value
    },
    watch: {
      value (val) {
        this.newValue = val
        this.$emit('valueChanged', this.newValue)
      }
    },
    computed: {
      values: function () {
        const values = []
        for (let i = 0; i <= 10; i++) {
          values.push(i)
        }
        return values
      },
      sliderClass: function () {
        const val = this.newValue
        if (val <= 2) {
          return 'slider-red'
        } else if (val <= 4) {
          return 'slider-orange'
        } else if (val <= 6) {
          return 'slider-yellow'
        } else if (val <= 8) {
          return 'slider-greenYellow'
        } else if (val <= 10) {
          return 'slider-green'
        } else {
          return ''
        }
      }
    },
    methods: {
      setSlider (value) {
        this.newValue = value
        this.$emit('input', this.newValue)
      },
      getStyle (value) {
        const width = this.values.length > 2 ? 100 / (this.values.length - 1) : 100
        return {
          transform: 'translateX(-50%)',
          position: 'absolute',
          textAlign: 'center',
          width: `${width}%`,
          left: `${value * width}%`
        }
      }
    },
    components: {
      [Slider.name]: Slider
    }
  }
</script>
<style lang="scss" scoped>
  .discrete-buttons {
    position: relative;
    margin-bottom: 20px;
    span {
      cursor: pointer;
    }
  }
</style>
